import type { ButtonHTMLAttributes, ReactNode } from 'react';
import styles from './DSButton.module.css';

export type DSButtonVariant =
  | 'primary'
  | 'bordered'
  | 'glass'
  | 'text'
  | 'destructive';
export type DSButtonSize = 'large' | 'medium' | 'small';

export interface DSButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: DSButtonVariant;
  size?: DSButtonSize;
  iconOnly?: boolean;
  leadingIcon?: ReactNode;
  trailingIcon?: ReactNode;
  children?: ReactNode;
}

/**
 * DSButton — порт ios/Aura/Components/DSButton.swift (упрощённый).
 *
 * Варианты (subset из iOS): primary, bordered, glass, text, destructive.
 * Размеры: large (48px), medium (40px), small (32px).
 *
 * В Phase 1+ дополняется gradient(geo/gold), filled(muted/secondary), liquidGlass,
 * анимированными leading-asset (Lottie).
 */
export function DSButton({
  variant = 'primary',
  size = 'medium',
  iconOnly = false,
  leadingIcon,
  trailingIcon,
  children,
  className,
  ...rest
}: DSButtonProps) {
  const classes = [
    styles.button,
    styles[variant],
    iconOnly ? styles.iconOnly : styles[size],
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button className={classes} {...rest}>
      {leadingIcon}
      {children}
      {trailingIcon}
    </button>
  );
}
